// src/jira/field-set-view/types.ts
var JiraFieldSetViewAriResourceOwner = "jira", JiraFieldSetViewAriResourceType = "field-set-view";

export {
  JiraFieldSetViewAriResourceOwner,
  JiraFieldSetViewAriResourceType
};
